import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

const axiosInstance = axios.create({
  baseURL: API,
  withCredentials: true,
});

/** Owner — GET /notifications */
export const fetchNotifications = async (params = {}) => {
  const res = await axiosInstance.get("/notifications", { params });
  return res.data;
};

/** Owner — GET /notifications/unread-count */
export const fetchUnreadCount = async () => {
  const res = await axiosInstance.get("/notifications/unread-count");
  return res.data;
};

/** Owner — PATCH /notifications/:id/read */
export const markNotificationRead = async (id) => {
  const res = await axiosInstance.patch(`/notifications/${id}/read`);
  return res.data;
};

/** Owner — PATCH /notifications/read-all */
export const markAllNotificationsRead = async () => {
  const res = await axiosInstance.patch("/notifications/read-all");
  return res.data;
};

/** Owner — DELETE /notifications/:id */
export const deleteNotification = async (id) => {
  const res = await axiosInstance.delete(`/notifications/${id}`);
  return res.data;
};
